import {api} from '../../../system/api';

export default {
    fetchLogs: (object, object_id, params = {}) => api.get(`${object}/${object_id}/logs`, {params, singleRequest: true}),
    fetchPackageCheckingLogs: (packageId) => api.get(`packages/${packageId}/checking-item-logs`, {singleRequest: true}),
}
